
/**
 * Action type to signal the arriving or updating of a knocking participant.
 */
export const KNOCKING_PARTICIPANT_ARRIVED_OR_UPDATED = 'KNOCKING_PARTICIPANT_ARRIVED_OR_UPDATED';

/**
 * Action type to signal the leave of a knocking participant.
 */
export const KNOCKING_PARTICIPANT_LEFT = 'KNOCKING_PARTICIPANT_LEFT';

/**
 * Action type to set the new state of the lobby mode.
 */
export const SET_LOBBY_MODE_ENABLED = 'SET_LOBBY_MODE_ENABLED';

/**
 * Action type to set the loading state of the lobby toggle.
 */
export const SET_LOBBY_LOADING = 'SET_LOBBY_LOADING';

/**
 * Action type to store the authoritative room-level lobby decision received
 * from room metadata (set by the room creator / last moderator to toggle it).
 */
export const SET_LOBBY_OVERRIDE_RECEIVED = 'SET_LOBBY_OVERRIDE_RECEIVED';

/**
 * Action type to set the knocking state of the participant.
 */
export const SET_KNOCKING_STATE = 'SET_KNOCKING_STATE';

/**
 * Action type to set the password join failed status.
 */
export const SET_PASSWORD_JOIN_FAILED = 'SET_PASSWORD_JOIN_FAILED';

/**
 * Enable Lobby through jwt o api.
 */
export const ENABLE_LOBBY = 'ENABLE_LOBBY';

/**
 * Open Lobby screen.
 */
export const OPEN_LOBBY = 'OPEN_LOBBY';

/**
  * Handles a sound while waiting in lobby or while starting the meeting.
  */
export const HANDLE_SOUND = 'HANDLE_SOUND';


export const DISABLE_LOBBY_SOUND = 'DISABLE_LOBBY_SOUND';
